<?xml version="1.0" encoding="UTF-8"?>
<svg id="Livello_2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 22 22.2">
  <defs>
  </defs>
  <path class="st0" d="M15.3,10.2h-3.5v-3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v3.5h-3.5c-.5,0-.9.4-.9.9s.4.9.9.9h3.5v3.5c0,.5.4.9.9.9s.9-.4.9-.9v-3.5h3.5c.5,0,.9-.4.9-.9s-.4-.9-.9-.9Z"/>
  <path class="st0" d="M15.5.7H6.3C3.1.7.6,3.2.6,6.3v9.5c0,3.1,2.5,5.7,5.7,5.7h9.2c3.2,0,5.7-2.6,5.7-5.7V6.3c0-3.1-2.5-5.6-5.7-5.6ZM19.6,15.8c0,2.2-1.8,4-4,4H6.2c-2.2,0-4-1.8-4-4V6.3c0-2.2,1.8-4,4-4h9.4c2.2,0,4,1.8,4,4,0,0,0,9.5,0,9.5Z"/>
</svg>